import React, { useEffect, useState } from 'react';
import { isSupportedVariable } from '../../lib/extraVariables';
import _each from 'lodash/each';
import _head from 'lodash/head';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { CaptionText, CriticalSmIcon } from '@paypalcorp/pp-react';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC, SCREEN } from '../../utilsV3/fptiConstants';
import { TextArea } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';

const ExtraVariablesTextArea = (props) => {
  const {
    input,
    meta: { touched, error, active },
    id,
    label,
    validateOnBlur,
  } = props;
  const hasError = validateOnBlur
    ? !active && touched && error
    : touched && error;
  const [errors, setErrors] = useState('');

  const getErrorHtml = (value) => {
    const variables = value.split('\n');
    const unsupportedVariables = [];
    _each(variables, (variable) => {
      const key = _head(variable.split('='));
      if (key && !isSupportedVariable(key)) {
        unsupportedVariables.push(key);
      }
    });

    if (_isEmpty(unsupportedVariables)) {
      return null;
    }

    trackEventWithData(FPTI_SPEC.FIELD_LEVEL_ERROR_IM, {
      error_code: 'INPUT_FIELD_VALIDATION_ERROR',
      error_desc: id,
      error_detail: 'Unsupported button variables',
      screen: SCREEN.ADVANCED_SETTINGS,
    });

    return (
      <div className="error-block">
        <CriticalSmIcon id="error-icon" size="sm" />
        <div className="error-message">
          <CaptionText className="line-1">
            {unsupportedVariables.length === 1 ? (
              <Message id="buttonsV3.fieldErrors.advancedVariables.single.message" />
            ) : (
              <Message id="buttonsV3.fieldErrors.advancedVariables.multiple.message" />
            )}
          </CaptionText>
          <div className="line-2">
            {unsupportedVariables.length === 1 ? (
              <CaptionText>
                <Message id="buttonsV3.fieldErrors.advancedVariables.single.listHeader" />
              </CaptionText>
            ) : (
              <CaptionText>
                <Message id="buttonsV3.fieldErrors.advancedVariables.multiple.listHeader" />
              </CaptionText>
            )}
            <ul>
              {_map(unsupportedVariables, (variable, index) => {
                return <li key={index}>{variable}</li>;
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const handleBlur = () => {
    const errorHtml = getErrorHtml(input?.value);
    setErrors(errorHtml);
  };

  useEffect(() => {
    handleBlur();
  }, []);

  return (
    <div className={`extra-variables-text-area ${hasError ? 'has-error' : ''}`}>
      <div>
        <TextArea
          id={id}
          label={label}
          {...input}
          onBlur={(event) => {
            input.onBlur(event);
            handleBlur();
          }}
        />
        {errors}
      </div>
    </div>
  );
};

ExtraVariablesTextArea.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  id: PropTypes.string,
  validateOnBlur: PropTypes.bool,
};

export default ExtraVariablesTextArea;
